/* eslint-disable */
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'coursetype',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      submitted: false,
      name: '',
      course:'',
      courseId:'',
      courseTypeList:'',
      removecourseTypeId:'',
      updateCourseTypeForm:false,
      updateId:'',
      selectedCourseType:''
    }
  },
  computed: {
    ...mapGetters([
      'getCourseTypeDataState',
    ]),
    geCourseTypeList() {
      this.$store.dispatch('getCourseTypeFun').then((res) => {
        this.courseTypeList = this.$store.getters.getCourseTypeDataState.data
      }).catch((err) => {})
      this.$store.dispatch('sectionbycourseId', {
          id:  this.$route.params.courseId
      }).then((res) => {
        this.selectedCourseType = res.data.data.course_type.id
      })
    },
  },
  mounted() {
    this.geCourseTypeList
    this.courseId = this.$route.params.courseId
  },
  methods: {
    geCourseTypeListAgain() {
      this.$store.dispatch('getCourseTypeFun').then((res) => {
        this.courseTypeList = this.$store.getters.getCourseTypeDataState.data
      }).catch((err) => {})
    },
   createCourseTypeConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name
          }
          this.$store.dispatch('createCourseTypeFun', data)
            .then((res) => {
              this.name = '',
              toast.success(res.data.msg);
              this.$validator.reset();
              this.geCourseTypeListAgain()
            })
            .catch((err) => { })
          return
        }
      });
    },
    removeCourseType(id) {
      $('#removProModalAgain').modal();
      this.removecourseTypeId = id
    },
    RemoveProConfirmationagain(){
      this.$store.dispatch('removeCourseTypeByIdFun', {
        id: this.removecourseTypeId
      }).then((res) => {
        this.geCourseTypeListAgain()
      }).catch((err) => {})
    },
    updateCourseType(updateid, updateName){
      this.updateCourseTypeForm = true
      this.updateId = updateid
      this.name = updateName;
    },
    updateCourseTypeConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name,
          }
          console.log(this.updateId,this.name )
          this.$store.dispatch('updateCourseTypeByIdFun', {
            data:{
              data: data,
              id: this.updateId
            }
          })
            .then((res) => {
              this.updateCourseTypeForm = false
              this.name = ''
              this.$validator.reset();
              toast.success(res.data.msg);
              this.geCourseTypeListAgain()
            })
            .catch((err) => { })
          return
        }
      });
    },
    selectForCourse(selectId){
      this.submitted = true;
      let data = {
        course_type: selectId
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.courseId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.selectedCourseType = res.data.data.course_type
          toast.success("Course Type Updated Successfully" || res.data.msg);
        }
      }).catch((err) => {})
      return
    }
  }
}